<template>
  <ButtonComponent v-bind="{ ...data }" />
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
